import {Measure} from "../../services/GreenLoanService";
import {Accordion, AccordionDetails, AccordionSummary, Card, Typography} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {MeasureCardToggleOld} from "../MeasureCardToggleOld";
import {Dispatch, SetStateAction, useState} from "react";
import CircleIcon from '@mui/icons-material/Circle';
import {MeasureCardToggleNew} from "../MeasureCardToggleNew";

interface Props {
    measure: Measure,
    expandedMeasureNumber: number | null,
    setExpandedMeasureNumber: Dispatch<SetStateAction<number | null>>
}

export function MeasureCard(props: Props) {
    const {
        expandedMeasureNumber,
        setExpandedMeasureNumber,
        measure
    } = props
    const [isNewMeasureChecked, setIsNewMeasureChecked] = useState<boolean>(false)
    const [isOldMeasureChecked, setIsOldMeasureChecked] = useState<boolean>(false)

    const shouldExpand = measure.measureNumber === expandedMeasureNumber

    function handleMeasureClick() {
        shouldExpand ? setExpandedMeasureNumber(null) : setExpandedMeasureNumber(measure.measureNumber)
    }

    return (
        <Card variant="outlined" style={{marginTop: "10px"}}>
            <Accordion expanded={shouldExpand}>
                <AccordionSummary
                    onClick={handleMeasureClick}
                    expandIcon={<ExpandMoreIcon color="primary"/>}
                    sx={{
                        display: "flex",
                        "& .MuiAccordionSummary-content": {
                            alignItems: "center"
                        }
                    }}
                >
                    <Typography fontWeight="bold" color="primary" fontFamily="SpareBank1-medium">
                        {measure.title}
                    </Typography>
                    {(isNewMeasureChecked || isOldMeasureChecked) && !shouldExpand &&
                        <CircleIcon color={"success"} sx={{
                            fontSize: "10px",
                            marginLeft: "10px"
                        }}/>}
                </AccordionSummary>
                <AccordionDetails sx={{paddingTop: "0px"}}>
                    <MeasureCardToggleNew measure={measure}
                                          setIsNewMeasureChecked={setIsNewMeasureChecked}
                    />
                    <MeasureCardToggleOld measure={measure}
                                          setIsOldMeasureChecked={setIsOldMeasureChecked}
                    />
                </AccordionDetails>
            </Accordion>

        </Card>
    )
}